export default __webpack_public_path__ + "static/industryHeroSectionBg-e6ae6a79476967c68e3e761411724450.png";